module.exports = __webpack_public_path__ + "img/img32.3320bcae.png";